import { useHasAppRole } from "./useHasAppRole";
/**
 * Returns boolean whether a user has an active subscription.
 * A user has an active subscription if they have the "subscriber" role.
 */
export const useHasActiveSubscription = () => {
  return useHasAppRole("subscriber");
};
